<template>
  <div>
    <!-- REVENDAS (quando não é Nuts) -->
    <b-row v-if="isClienteRevenda">
      <div class="card-form">
        <div class="card-list">
          <div class="card-form-assinatura__inner">
            <div class="card-input" style="padding-top: 30px">
              <h3>Verifique sua assinatura com nosso Parceiro:</h3>
              <br />
              <h3 style="text-align: center">
                {{ dadosRevenda.nome_revenda }} <br />
                Telefone: {{ dadosRevenda.fone_revenda }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </b-row>

    <!-- ================= RENOVAÇÃO ================= -->
    <b-row>
      <b-col class="justify-content-center" md="12" v-if="ocultaPlans && idRevenda === 1">
        <div :class="{ 'assinatura-page-container': shouldShowAppsContratadosSection }">
        <div class="card-form shadow h-100" :class="{ 'assinatura-shell-clean': shouldShowAppsContratadosSection }">
          <div class="card-form-assinatura__inner p-4" :class="{ 'assinatura-shell-clean__inner': shouldShowAppsContratadosSection }">
            <!-- HEADER -->
            <div class="text-center mb-4 assinatura-top-header">
              <h6 class="text-muted">Dúvidas? (49) 3550 0600</h6>
              <h2>🚀 Continue crescendo com a Nuts</h2>

              <template v-if="!shouldShowAppsContratadosSection">
                <p class="text-muted mb-1">
                  Você está no plano <strong>{{ planoPrincipalNome }}</strong>
                </p>

                <p class="valor-destaque">
                  R$ {{ formatValorReal(assinatura.valor) }}
                </p>

                <small class="text-muted">
                  Válido até {{ formatDate(assinatura.data_validade) }}
                </small>
              </template>

              <p v-else class="text-muted mb-0">
                Confira os dados do seu plano e dos apps ativos para transparência da cobrança.
              </p>
            </div>

            <div :class="{ 'assinatura-layout': shouldShowAppsContratadosSection }">
              <div :class="{ 'assinatura-main-column': shouldShowAppsContratadosSection }">
                <div :class="{ 'contratacao-bloco renovacao-card': shouldShowAppsContratadosSection }" v-if="planoAtual && showAssinaturaCard  && !assinatura.assinatura_diferenciada">
              <div v-if="shouldShowAppsContratadosSection" class="renovacao-header mb-4">
                <h5 class="mb-1">Renovar Plano Nuts</h5>
                <p class="text-muted mb-0">
                  Escolha a forma de pagamento para renovar seu plano anual.
                </p>
                <small class="renovacao-observacao d-block mt-2">
                  Apps mensais ativos podem ser incorporados ao próximo ciclo anual nesta renovação.
                </small>
              </div>

              <!-- STEPS -->
              <div class="assinatura-steps mb-4">
                <div :class="['step-item', { active: step >= 1 }]">
                  1. Pagamento
                </div>
                <div :class="['step-item', { active: step >= 2 }]">
                  2. Plugins
                </div>
                <div :class="['step-item', { active: step >= 3 }]">
                  3. Finalizar
                </div>
              </div>

              <div>
              <!-- ================= STEP 1 ================= -->
              <div v-if="step === 1">
                <h5 class="text-center mb-3">
                  Escolha a forma de pagamento
                </h5>

                <div class="pagamentos-grid">
                  <div v-for="(opcao, key) in opcoesOrdenadas" :key="key" class="payment-card"
                    :class="{ selected: opcaoSelecionada === key }" @click="selecionarOpcao(key)">
                    <div class="payment-title">
                      <span>{{ opcao.icon }}</span>
                      <strong>{{ opcao.label }}</strong>
                    </div>

                    <div class="price-main">
                      <template v-if="opcao.parcela">
                        {{ opcao.parcela }}x de
                        R$ {{ formatValorReal(valorOpcaoParcelaComApps(opcao)) }}
                      </template>

                      <template v-else-if="opcao.mensal">
                        R$ {{ formatValorReal(valorOpcaoMensalComApps(opcao)) }} / mês
                      </template>

                      <template v-else>
                        R$ {{ formatValorReal(valorOpcaoTotalComApps(opcao)) }}
                      </template>
                    </div>

                    <small v-if="opcao.destaque" class="text-success d-block">
                      {{ opcao.destaque }}
                    </small>

                    <small v-if="opcao.sub" class="text-muted d-block mt-1">
                      {{ opcao.sub }}
                    </small>
                  </div>
                </div>

                <div class="text-center mt-4">
                  <b-button variant="primary" size="lg" :disabled="!opcaoSelecionada" @click="step = 2">
                    Continuar →
                  </b-button>
                </div>
              </div>

              <!-- ================= STEP 2 ================= -->
              <div v-if="step === 2" class="plugins-box mt-4">
                <h5 class="text-center mb-1">
                  🚀 Turbine seu sistema
                </h5>

                <p class="text-center text-muted mb-4">
                  Aproveite estes recursos extras com desconto exclusivo para
                  clientes Nuts
                </p>

                <b-row>
                  <!-- CERTIFICADO -->
                  <b-col md="6">
                    <div class="plugin-card destaque" @click="togglePlugin('certificado')">
                      <div class="plugin-badge">
                        🔥 Mais vendido
                      </div>

                      <b-form-checkbox v-model="plugins.certificado.ativo" switch class="mb-2" :disabled="isLoading || pixLoading || pixConfirmado || renovacaoConcluida" @click.stop>
                        Certificado Digital A1
                      </b-form-checkbox>

                      <div class="plugin-price">
                        <span class="old-price">
                          R$ 250,00
                        </span>

                        <span class="new-price">
                          R$ {{ formatValorReal(plugins.certificado.valor) }}
                        </span>
                      </div>

                      <div class="plugin-desc">
                        Emita NF-e sem complicação. Instalação automática no
                        sistema.
                      </div>
                    </div>
                  </b-col>

                  <!-- TEF -->
                  <b-col md="6">
                    <div class="plugin-card" @click="togglePlugin('tef')">
                      <div class="plugin-badge blue">
                        💳 PDV Completo
                      </div>

                      <b-form-checkbox v-model="plugins.tef.ativo" switch class="mb-2" :disabled="isLoading || pixLoading || pixConfirmado || renovacaoConcluida" @click.stop>
                        TEF Integrado
                      </b-form-checkbox>

                      <div class="plugin-price">
                        <span class="new-price">
                          + R$ {{ formatValorReal(plugins.tef.valor) }}
                        </span>
                      </div>

                      <div class="plugin-desc">
                        Conecte maquininhas direto no PDV. Mais rapidez no
                        caixa.
                      </div>
                    </div>
                  </b-col>
                </b-row>

                <div class="d-flex justify-content-between mt-4">
                  <b-button variant="outline-secondary" @click="step = 1">
                    ← Voltar
                  </b-button>

                  <b-button variant="success" size="lg" @click="step = 3">
                    Continuar →
                  </b-button>
                </div>
              </div>

              <!-- ================= STEP 3 ================= -->
              <div v-if="step === 3">
                <div v-if="opcaoSelecionada === 'pix' && pixGerado && !pixConfirmado"
                  class="alert alert-warning d-flex align-items-start mb-3 aviso-pix-pendente">
                  <div class="mr-2" style="font-size: 20px">⚠️</div>
                  <div>
                    <strong>Pagamento PIX em processamento</strong>
                    <div class="mb-1">
                      Não atualize e não feche esta tela até a confirmação automática do pagamento.
                    </div>
                    <small class="text-muted">
                      Assim que identificarmos o pagamento, a renovação será concluída automaticamente.
                    </small>
                  </div>
                </div>
                <div class="card-resumo shadow">
                  <h5 class="mb-3">
                    Resumo da renovação
                  </h5>

                  <div class="resumo-item">
                    <span>Plano</span>
                    <strong>{{ planoPrincipalNome }}</strong>
                  </div>

                  <div class="resumo-item">
                    <span>Plano Nuts</span>
                    <strong>R$ {{ formatValorReal(valorPlano) }}/ano</strong>
                  </div>

                  <div class="resumo-item">
                    <span>Apps selecionados</span>
                    <strong>
                      R$ {{ formatValorReal(appsPendingRenewalTotalSelecionado) }}/ano
                    </strong>
                  </div>

                  <div v-if="plugins.certificado.ativo" class="resumo-item">
                    <span>Certificado Digital</span>
                    <strong>
                      R$ {{ formatValorReal(plugins.certificado.valor) }}
                    </strong>
                  </div>

                  <div v-if="plugins.tef.ativo" class="resumo-item">
                    <span>TEF Integrado</span>
                    <strong>
                      R$ {{ formatValorReal(plugins.tef.valor) }}
                    </strong>
                  </div>

                  <hr />

                  <div class="resumo-total">
                    <span>Total da renovação</span>
                    <strong>
                      R$ {{ formatValorReal(valorSelecionado) }}
                    </strong>
                  </div>

                  <!-- CTA -->
                  <b-button variant="success" block size="lg" class="mt-3"
                    :disabled="!opcaoSelecionada || isLoading || pixLoading || pixConfirmado || renovacaoConcluida" @click="iniciarPagamento">
                    {{ renovacaoConcluida ? "Renovação iniciada" : "🚀 Renovar agora" }}
                  </b-button>

                  <!-- ================= PIX (gerado somente no passo 3) ================= -->
                  <div v-if="opcaoSelecionada === 'pix' && pixGerado" class="pix-box mt-3 text-center">
                    <img v-if="qrCodePix" :src="qrCodePix" class="pix-qrcode" />

                    <b-button v-if="codigoPix" class="mt-2" size="sm" variant="outline-secondary" @click="copiarPix">
                      Copiar PIX
                    </b-button>

                    <div class="pix-warning-text mt-3">
                      <strong>Importante:</strong> após realizar o pagamento, mantenha esta tela aberta até a
                      confirmação automática.
                    </div>

                    <small v-if="pixExpirationDate" class="text-muted d-block mt-2">
                      Expira em {{ formatDateTime(pixExpirationDate) }}
                    </small>
                  </div>

                  <!-- ================= CARTÃO (abre somente no passo 3) ================= -->
                  <div v-if="
                    opcaoSelecionada &&
                    String(opcaoSelecionada).startsWith('cartao') &&
                    chamaCartao
                  " class="mt-3">
                    <CardForm @card-success="handleCardSuccess" :form-data="formData"
                      @input-card-number="updateCardNumber" @input-card-name="updateCardName"
                      @input-card-month="updateCardMonth" @input-card-year="updateCardYear"
                      @input-card-cvv="updateCardCvv" :plano="assinatura.plano" :valor="valorSelecionado"
                      :id_plan="assinatura.id_plan" :vezesByPlan="vezesByPlan" :isSale="true"
                      :apps-renovacao="appsRenovacaoPayload()" />
                  </div>
                </div>

                <div class="text-center mt-4">
                  <b-button variant="outline-secondary" class="mr-2" @click="step = 2">
                    ← Voltar
                  </b-button>
                </div>
              </div>
              </div>
                </div>

                <div v-if="shouldShowAppsContratadosSection && appsPendingRenewalNormalizados.length" class="contratacao-bloco apps-pending-renewal-card mt-4">
                  <div class="apps-pending-renewal-header">
                    <div>
                      <h5 class="mb-1">Apps ativos para incluir na renovação</h5>
                      <p class="text-muted mb-0">
                        Estes apps estão ativos na sua empresa. Mantenha selecionados os que deseja incluir no próximo ciclo anual.
                      </p>
                    </div>
                  </div>

                  <div class="apps-pending-renewal-list">
                    <div
                      v-for="app in appsPendingRenewalNormalizados"
                      :key="app.id"
                      class="app-pending-renewal-item"
                    >
                      <b-form-checkbox
                        :checked="isAppPendingRenewalSelected(app.code)"
                        :disabled="isLoading || pixLoading || pixConfirmado || renovacaoConcluida"
                        class="app-pending-renewal-checkbox mb-0"
                        @change="toggleAppPendingRenewal(app.code, $event)"
                      >
                        <span class="app-pending-renewal-name">{{ app.nome }}</span>
                      </b-form-checkbox>

                      <div class="app-pending-renewal-price">
                        {{ appPendingRenewalPriceLabel(app) }}
                      </div>
                    </div>
                  </div>

                  <div class="apps-pending-renewal-summary">
                    <div class="resumo-total resumo-total--mensal resumo-total--apps-pending">
                      <span>Total anual dos apps selecionados:</span>
                      <strong>R$ {{ formatValorReal(appsPendingRenewalTotalSelecionado) }}/ano</strong>
                    </div>
                  </div>
                </div>

                <div v-if="shouldShowAppsContratadosSection && itemsTable.length" class="card-form shadow-sm faturas-card faturas-card--inside-main mt-4">
                  <div class="card-form-assinatura__inner p-4">
                    <b-table :items="itemsTable" :fields="fieldsAssinaturas" small responsive :busy="assinaturasLoading">
                      <template #table-busy>
                        <div class="text-center w-100 my-3">
                          <b-spinner class="mr-2" small></b-spinner>
                          Carregando faturas...
                        </div>
                      </template>

                      <template #cell(data_vencimento)="row">
                        {{ formatDate(row.item.data_vencimento) }}
                      </template>

                      <template #cell(valor)="row">
                        R$ {{ formatValorReal(row.item.valor) }}
                      </template>

                      <template #cell(status)="row">
                        <b-badge :variant="getFaturaStatusMeta(row.item).variant" class="fatura-status-badge">
                          {{ getFaturaStatusMeta(row.item).label }}
                        </b-badge>
                      </template>

                      <template #cell(acoes)="row">
                        <b-button v-if="row.item.url_boleto && !row.item.pagamento && !row.item.cancelado" :href="row.item.url_boleto" target="_blank"
                          size="sm" variant="outline-primary">
                          Abrir boleto
                        </b-button>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>

              <div v-if="shouldShowAppsContratadosSection" class="assinatura-side-column">
                <div class="contratacao-bloco plano-principal-card mb-3">
                  <h5 class="mb-2">Plano Nuts</h5>
                  <p class="plano-principal-nome mb-2">{{ planoPrincipalNome }}</p>
                  <p class="valor-destaque valor-destaque--small mb-3">
                    R$ {{ formatValorReal(planoPrincipalAnual) }}
                    <span>/ano</span>
                  </p>

                  <p class="mb-1"><strong>Cobrança:</strong> Anual</p>
                  <p class="mb-1"><strong>Status:</strong> {{ planoPrincipalStatusLabel }}</p>
                  <p class="mb-0"><strong>Vencimento:</strong> {{ formatDate(assinatura.data_validade) }}</p>
                </div>

                <div class="contratacao-bloco apps-contratados-card mb-3">
                  <h5 class="mb-1">Apps contratados</h5>
                  <p class="text-muted mb-3">Módulos e plugins ativos na sua empresa.</p>

                  <div v-if="appsContratadosNormalizados.length">
                    <div
                      v-for="app in appsContratadosNormalizados"
                      :key="app.id"
                      class="app-contratado-item"
                    >
                      <p class="mb-1"><strong>{{ app.nome }}</strong></p>
                      <p class="mb-1 app-tipo-label">{{ app.tipoLabel }}</p>

                      <p v-if="app.shouldShowIncluso" class="mb-1"><strong>Incluso</strong></p>

                      <p v-else-if="app.quantity > 1" class="mb-1">
                        {{ app.quantity }} {{ app.quantityLabel }} x R$ {{ formatValorReal(app.unitPrice) }} = R$ {{ formatValorReal(app.totalPrice) }}/mês
                      </p>

                      <p v-else class="mb-1">
                        R$ {{ formatValorReal(app.totalPrice) }}/mês
                      </p>

                      <p v-if="app.showSourceLine" class="mb-0 text-muted">{{ app.sourceLabel }}</p>
                    </div>
                  </div>

                  <div v-else class="sem-apps-box sem-apps-box--highlight">
                    <p class="mb-1"><strong>Você ainda não possui apps adicionais contratados.</strong></p>
                    <p class="mb-3 text-muted">
                      Explore o Marketplace para conhecer módulos e plugins
                      que podem complementar sua operação.
                    </p>
                    <b-button variant="outline-primary" href="/#/apps">
                      Conhecer Marketplace
                    </b-button>
                  </div>
                </div>

                <div class="contratacao-bloco resumo-financeiro-card">
                  <h5 class="mb-2">Resumo da renovação</h5>

                  <div class="resumo-item">
                    <span>Plano Nuts:</span>
                    <strong>R$ {{ formatValorReal(valorPlanoResumoRenovacao) }}/ano</strong>
                  </div>
                  <div class="resumo-item">
                    <span>Apps selecionados:</span>
                    <strong>R$ {{ formatValorReal(appsPendingRenewalTotalSelecionado) }}/ano</strong>
                  </div>
                  <div v-if="valorPlugins" class="resumo-item">
                    <span>Plugins extras:</span>
                    <strong>R$ {{ formatValorReal(valorPlugins) }}</strong>
                  </div>
                  <div class="resumo-total resumo-total--mensal">
                    <span>Total da renovação:</span>
                    <strong>R$ {{ formatValorReal(totalRenovacaoResumo) }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </b-col>
    </b-row>

    <!-- ================= HISTÓRICO ================= -->
    <b-row class="mt-4 justify-content-center" v-if="ocultaPlans && idRevenda === 1 && itemsTable.length && !shouldShowAppsContratadosSection">
      <b-col md="12" :lg="shouldShowAppsContratadosSection ? 12 : 8">
        <div :class="{ 'assinatura-page-container': shouldShowAppsContratadosSection }">
        <div class="card-form shadow-sm" :class="{ 'bloco-faturas': !shouldShowAppsContratadosSection, 'faturas-card': shouldShowAppsContratadosSection }">
          <div class="card-form-assinatura__inner p-4">
            <div class="d-flex align-items-center justify-content-between mb-3 faturas-header">
              <h5 class="mb-0">Faturas</h5>
              <small class="text-muted">Histórico de cobrança</small>
            </div>

            <b-table :items="itemsTable" :fields="fieldsAssinaturas" small responsive :busy="assinaturasLoading">
              <template #table-busy>
                <div class="text-center w-100 my-3">
                  <b-spinner class="mr-2" small></b-spinner>
                  Carregando faturas...
                </div>
              </template>

              <template #empty>
                <div class="text-center text-muted my-3">
                  Nenhuma fatura encontrada.
                </div>
              </template>

              <template #cell(data_vencimento)="row">
                {{ formatDate(row.item.data_vencimento) }}
              </template>

              <template #cell(valor)="row">
                R$ {{ formatValorReal(row.item.valor) }}
              </template>

              <template #cell(status)="row">
                <b-badge :variant="getFaturaStatusMeta(row.item).variant" class="fatura-status-badge">
                  {{ getFaturaStatusMeta(row.item).label }}
                </b-badge>
              </template>

              <template #cell(acoes)="row">
                <b-button v-if="row.item.url_boleto && !row.item.pagamento && !row.item.cancelado" :href="row.item.url_boleto" target="_blank"
                  size="sm" variant="outline-primary">
                  Abrir boleto
                </b-button>
              </template>
            </b-table>
          </div>
        </div>
        </div>
      </b-col>
    </b-row>

    <!-- SEM PLANO -->
    <b-row class="plan__table" v-if="dataReady && !ocultaPlans && !isRevenda && !isClienteRevenda && !assinatura.assinatura_diferenciada && !isNuts">
      <b-col md="12">
        <div class="plan-picker card-form shadow p-3 plan-card--alert">
          <div class="plan-card__header bg-warning text-dark">
            <h5 class="m-0">⚠ Você ainda está sem plano</h5>
          </div>

          <div class="plan-card__body">
            <p class="mb-3">
              Identificamos que sua empresa ainda não possui um plano ativo. Para
              continuar utilizando o sistema, verifique sua assinatura com a
              Nuts.
            </p>

            <b-button variant="success" block @click="abrirWhatsApp">
              Falar com a Nuts no WhatsApp
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- parceiros -->
    <b-row v-if="isRevenda && idRevenda === 1">
      <b-col class="justify-content-center" md="12">
        <div class="card-form shadow h-100">
          <div class="card-form-assinatura__inner p-4">
            <!-- HEADER -->
            <div class="text-center mb-4">
              <h6 class="text-muted">Dúvidas? (49) 3550 0600</h6>
              <h2>🚀 Continue crescendo com a Nuts</h2>

              <p class="text-muted mb-1">
                Você está no plano <strong>{{ assinatura.plano }}</strong>
              </p>

              <p class="valor-destaque">
                R$ {{ formatValorReal(assinatura.valor) }}
              </p>

              <small class="text-muted">
                Válido até {{ formatDate(assinatura.data_validade) }}
              </small>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { SistemaMixin, FormatMixin } from "@/modules/Application";
import { mapGetters, mapActions } from "vuex";
import AssinaturaData, { AssinaturaDataRequired } from "./AssinaturaData";
import CardForm from "../Cards/CardForm";

export default {
  name: "app-assinatura-renovacao-2026",
  mixins: [validationMixin, SistemaMixin, FormatMixin],
  components: { CardForm },

  data() {
    return {
      dataReady: false,
      ocultaPlans: true,
      step: 1,

      assinatura: {},
      assinaturaResumoPayload: {},

      plugins: {
        certificado: {
          nome: "Certificado Digital A1",
          valor: 190,
          ativo: false,
        },
        tef: {
          nome: "TEF Integrado",
          valor: 1069.90,
          ativo: false,
        },
      },

      // TABELA
      assinaturas: [],
      assinaturasLoading: false,

      // Loading
      isLoading: false,
      pixLoading: false,
      pixStatusLoading: false,
      renovacaoConcluida: false,
      telaEncerrada: false,

      // Pagamento
      opcaoSelecionada: null,

      // CARTÃO (CardForm)
      chamaCartao: false,
      vezesByPlan: 1,
      formData: {
        cardName: "",
        cardNumber: "",
        cardMonth: "",
        cardYear: "",
        cardCvv: "",
      },

      // PIX
      pixPaymentId: null,
      qrCodePix: null,
      codigoPix: null,
      pixPollTimer: null,
      pixExpirationDate: null,

      pixGerado: false,
      pixLastAmount: null,
      pixConfirmado: false,
      bloquearSaidaPix: false,
      appsPendingRenewalSelecionadosCodes: [],
      // Regras 2026
      planos2026: {}
    }
  },

  validations: { form: AssinaturaDataRequired },

  computed: {
    ...mapGetters([
      "itsblocked",
      "idRevenda",
      "dadosRevenda",
      "licenca",
      "isRevenda",
      "isNuts",
      "isClienteRevenda",
      "isClienteNutsDireto",
    ]),

    contaAssinaturaFlags() {
      const resumo = this.assinaturaResumoPayload || {};

      const isRevendaPayload = this.readBoolean(
        resumo.is_revenda,
        resumo.isRevenda,
        resumo.revenda,
      );

      const isClienteRevendaPayload = this.readBoolean(
        resumo.is_cliente_revenda,
        resumo.isClienteRevenda,
        resumo.cliente_revenda,
      );

      const isClienteNutsDiretoPayload = this.readBoolean(
        resumo.is_cliente_nuts_direto,
        resumo.isClienteNutsDireto,
        resumo.cliente_nuts_direto,
      );

      return {
        isRevenda: isRevendaPayload ?? !!this.isRevenda,
        isClienteRevenda: isClienteRevendaPayload ?? !!this.isClienteRevenda,
        isClienteNutsDireto: isClienteNutsDiretoPayload ?? !!this.isClienteNutsDireto,
      };
    },

    shouldShowAppsContratadosSection() {
      const flags = this.contaAssinaturaFlags;
      if (flags.isRevenda || flags.isClienteRevenda) return false;
      return flags.isClienteNutsDireto === true;
    },

    planoPrincipalNome() {
      const plano = this.assinatura?.plano;
      if (typeof plano === "string") return plano;
      return plano?.nome || plano?.name || "Plano atual";
    },

    planoPrincipalStatusLabel() {
      if (typeof this.assinatura?.status === "boolean") {
        return this.assinatura.status ? "Ativo" : "Inativo";
      }

      if (this.assinatura?.status === 1 || this.assinatura?.status === "1") return "Ativo";
      if (this.assinatura?.status === 0 || this.assinatura?.status === "0") return "Inativo";

      const status = String(this.assinatura?.status || "").toLowerCase();
      const statusMap = {
        active: "Ativo",
        ativo: "Ativo",
        paid: "Ativo",
        trialing: "Em teste",
        pending: "Pendente",
        overdue: "Em atraso",
        canceled: "Cancelado",
        cancelado: "Cancelado",
        inactive: "Inativo",
        inativo: "Inativo",
      };

      return statusMap[status] || "Ativo";
    },

    isPlanoPrincipalAnual() {
      return true;
    },

    appsContratadosRaw() {
      const resumo = this.assinaturaResumoPayload || {};
      return (
        resumo.apps_contratados ||
        resumo.appsContratados ||
        resumo.empresa_features ||
        resumo.empresaFeatures ||
        resumo.features_contratadas ||
        resumo.featuresContratadas ||
        []
      );
    },

    appsContratadosNormalizados() {
      if (!Array.isArray(this.appsContratadosRaw)) return [];

      return this.appsContratadosRaw
        .filter((item) => this.isAppAtivo(item))
        .map((item, index) => {
          const quantity = Math.max(1, Number(item.quantity ?? item.quantidade ?? 1));
          const unitPrice = this.readCurrency(
            item.unit_price,
            item.unitPrice,
            item.valor_unitario,
            item.preco_unitario,
            item.price,
          );

          const informedTotal = this.readCurrency(
            item.total_price,
            item.totalPrice,
            item.valor_total,
            item.preco_total,
            item.valor,
          );

          const totalPrice = informedTotal || (quantity > 1 ? unitPrice * quantity : unitPrice);

          return {
            id: item.id || item.feature_id || item.slug || `${item.nome || "app"}-${index}`,
            nome: item.nome || item.name || item.titulo || "App",
            tipoLabel: this.translateAppType(item),
            quantity,
            quantityLabel: item.quantity_label || item.quantityLabel || item.label_quantidade || "unidades",
            unitPrice,
            totalPrice,
            source: item.source,
            sourceLabel: this.translateAppSource(item.source),
            hasSource: !!item.source,
            shouldShowIncluso: String(item.source || "").toLowerCase() === "legacy" && Number(totalPrice) === 0,
            showSourceLine:
              !!item.source &&
              !(String(item.source || "").toLowerCase() === "legacy" && Number(totalPrice) === 0),
          };
        });
    },

    appsPendingRenewalRaw() {
      const resumo = this.assinaturaResumoPayload || {};
      return (
        resumo.apps_ativos_renovacao ||
        resumo.appsAtivosRenovacao ||
        resumo.apps_mensais_ativos ||
        resumo.appsMensaisAtivos ||
        resumo.apps_contratados_mensais ||
        resumo.appsContratadosMensais ||
        resumo.apps_monthly_to_yearly ||
        resumo.appsMonthlyToYearly ||
        resumo.monthly_apps_active ||
        resumo.activeMonthlyApps ||
        resumo.apps_pending_renewal_charge ||
        resumo.appsPendingRenewalCharge ||
        resumo.apps_pendentes_cobranca_renovacao ||
        resumo.appsPendentesCobrancaRenovacao ||
        resumo.apps_cortesia_renovacao ||
        resumo.appsCortesiaRenovacao ||
        []
      );
    },

    appsPendingRenewalNormalizados() {
      if (!Array.isArray(this.appsPendingRenewalRaw)) return [];

      return this.appsPendingRenewalRaw
        .filter((item) => this.isAppAtivo(item))
        .map((item, index) => {
          const code =
            item.code ||
            item.feature_code ||
            item.featureCode ||
            item.codigo ||
            item.slug ||
            item.feature?.code ||
            "";
          const quantity = Math.max(1, Number(item.quantity ?? item.quantidade ?? 1));
          const informedUnitPrice = this.readCurrency(
            item.unit_price,
            item.unitPrice,
            item.valor_unitario,
            item.preco_unitario,
            item.monthly_price,
            item.monthlyPrice,
            item.valor_mensal,
            item.preco_mensal,
            item.price,
          );

          const informedMonthlyTotal = this.readCurrency(
            item.total_price,
            item.totalPrice,
            item.valor_total,
            item.preco_total,
            item.monthly_total,
            item.monthlyTotal,
            item.total_monthly,
            item.valor_mensal_total,
            item.preco_mensal_total,
            item.valor,
          );

          const unitPrice =
            informedUnitPrice ||
            (informedMonthlyTotal ? informedMonthlyTotal / quantity : 0);
          const totalPrice = informedMonthlyTotal || unitPrice * quantity;
          const informedAnnualPrice = this.readCurrency(
            item.annual_price,
            item.annualPrice,
            item.valor_anual,
            item.preco_anual,
            item.annual_total,
            item.annualTotal,
            item.total_anual,
          );
          const nome = item.nome || item.name || item.titulo || "App";
          const rawQuantityLabel = item.quantity_label || item.quantityLabel || item.label_quantidade || "unidades";

          return {
            id: item.id || item.feature_id || item.slug || code || `app-pending-${index}`,
            code,
            nome,
            quantity,
            quantityLabel: this.pluralizeQuantityLabel(rawQuantityLabel, quantity),
            unitPrice,
            totalPrice,
            annualPrice: informedAnnualPrice || totalPrice * 12,
          };
        })
        .filter((app) => !!app.code);
    },

    appsPendingRenewalSelecionados() {
      return this.appsPendingRenewalNormalizados.filter((app) =>
        this.appsPendingRenewalSelecionadosCodes.includes(app.code),
      );
    },

    appsPendingRenewalTotalSelecionado() {
      return this.appsPendingRenewalSelecionados.reduce(
        (acc, app) => acc + this.readCurrency(app.annualPrice),
        0,
      );
    },

    planoPrincipalAnual() {
      return this.readCurrency(this.assinatura?.valor);
    },

    appsContratadosTotalMensal() {
      return this.appsContratadosNormalizados.reduce(
        (acc, app) => acc + this.readCurrency(app.totalPrice),
        0,
      );
    },

    valorPlanoResumoRenovacao() {
      return this.valorPlano || this.planoPrincipalAnual;
    },

    totalRenovacaoPlanoApps() {
      return Number(this.valorPlanoResumoRenovacao) + Number(this.appsPendingRenewalTotalSelecionado);
    },

    totalRenovacaoResumo() {
      return Number(this.totalRenovacaoPlanoApps) + Number(this.valorPlugins);
    },

    totalMensalAssinatura() {
      return Number(this.planoPrincipalAnual) + Number(this.appsContratadosTotalMensal);
    },

    showAssinaturaCard() {
      if (this.idRevenda != 1) return false;

      const planosValidos = ["1", "2", "3", "4", "6", "7"];
      if (!planosValidos.includes(String(this.assinatura.id_plan))) return false;

      if (!this.assinatura.data_validade) return true;

      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);

      const validade = new Date(this.assinatura.data_validade);
      validade.setHours(0, 0, 0, 0);

      // Permite renovação a partir de 30 dias antes do vencimento
      const diasAntesVencimento = 30;
      const dataLimite = new Date(validade);
      dataLimite.setDate(dataLimite.getDate() - diasAntesVencimento);

      return hoje >= dataLimite;
    },

    planoAtual() {
      return this.planos2026[String(this.assinatura.id_plan)] || null;
    },

    opcoesOrdenadas() {
      if (!this.planoAtual) return {};
      const { prioridade, opcoes } = this.planoAtual;

      const ordered = {};
      (prioridade || []).forEach((k) => {
        if (opcoes[k]) ordered[k] = opcoes[k];
      });

      Object.keys(opcoes || {}).forEach((k) => {
        if (!ordered[k]) ordered[k] = opcoes[k];
      });

      return ordered;
    },

    valorPlano() {
      if (!this.planoAtual || !this.opcaoSelecionada) return 0;
      const opcao = this.planoAtual.opcoes?.[this.opcaoSelecionada] || {};
      const valorTotal = this.readCurrency(opcao.valor_total, opcao.valorTotal);
      if (valorTotal) return valorTotal;

      const parcela = Number(opcao.parcela || 0);
      const valorBase = this.readCurrency(opcao.valor);
      return parcela > 1 ? valorBase * parcela : valorBase;
    },

    valorPlugins() {
      return Object.values(this.plugins)
        .filter((p) => p.ativo)
        .reduce((acc, p) => acc + this.readCurrency(p.valor), 0);
    },

    valorSelecionado() {
      return Number(this.valorPlano) + Number(this.appsPendingRenewalTotalSelecionado) + Number(this.valorPlugins);
    },

    modalidadeSelecionada() {
      if (!this.planoAtual || !this.opcaoSelecionada) return null;
      return this.planoAtual.opcoes?.[this.opcaoSelecionada]?.modalidade || null;
    },

    // tabela
    itemsTable() {
      return (this.assinaturas || []).map((b) => ({
        data_vencimento: b.data_vencimento,
        valor: b.valor,
        pagamento: !!b.recebido,
        cancelado: this.readBoolean(b.cancelado, b.canceled, b.cancelled) === true,
        status_raw: b.status || b.situacao || null,
        url_boleto: b.url_boleto,
      }));
    },

    fieldsAssinaturas() {
      return [
        { key: "data_vencimento", label: "Vencimento" },
        { key: "valor", label: "Valor" },
        { key: "status", label: "Status" },
        { key: "acoes", label: "Ações" },
      ];
    },
  },

  watch: {
    // Se mudou valor final (plugins), invalida PIX gerado para evitar QR errado
    valorSelecionado() {
      if (this.opcaoSelecionada === "pix" && this.pixGerado) {
        this.resetPixState();
      }
    },
  },

  beforeDestroy() {
    this.telaEncerrada = true;
    this.stopPixPolling();
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },

  async mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    await this.getDataInitSafe();
  },

  methods: {
    ...mapActions(["setLoading"]),

    readBoolean(...values) {
      for (const value of values) {
        if (typeof value === "boolean") return value;
        if (value === 1 || value === "1") return true;
        if (value === 0 || value === "0") return false;

        if (typeof value === "string") {
          const normalized = value.trim().toLowerCase();
          if (["true", "sim", "yes"].includes(normalized)) return true;
          if (["false", "nao", "não", "no"].includes(normalized)) return false;
        }
      }

      return null;
    },

    readCurrency(...values) {
      for (const value of values) {
        if (value === null || value === undefined || value === "") continue;

        if (typeof value === "number" && !Number.isNaN(value)) {
          return value;
        }

        const rawValue = String(value).trim().replace(/[^\d,.-]/g, "");
        if (!rawValue) continue;

        let normalizedValue = rawValue;

        if (rawValue.includes(".") && rawValue.includes(",")) {
          normalizedValue = rawValue.replace(/\./g, "").replace(",", ".");
        } else if (rawValue.includes(",")) {
          normalizedValue = rawValue.replace(",", ".");
        }

        const asNumber = Number(normalizedValue);
        if (!Number.isNaN(asNumber)) return asNumber;
      }

      return 0;
    },

    isAppAtivo(item = {}) {
      const explicitActive = this.readBoolean(
        item.ativo,
        item.active,
        item.is_active,
        item.isActive,
      );

      if (explicitActive !== null) return explicitActive;

      const status = String(item.status || "").trim().toLowerCase();
      if (["inativo", "inactive", "cancelado", "canceled", "disabled"].includes(status)) {
        return false;
      }

      return true;
    },

    translateAppSource(source) {
      const sourceMap = {
        marketplace: "Contratado",
        legacy: "Incluso",
        manual: "Liberado pela Nuts",
        revenda: "Liberado pela revenda",
      };

      return sourceMap[String(source || "").toLowerCase()] || "Contratado";
    },

    translateAppType(item = {}) {
      const rawType = String(item.tipo || item.type || item.kind || "").toLowerCase();

      if (["plugin", "plugins"].includes(rawType)) return "Plugin";
      if (["modulo", "módulo", "module", "modules"].includes(rawType)) return "Módulo";

      const pluginFlag = this.readBoolean(item.is_plugin, item.isPlugin, item.plugin);
      if (pluginFlag === true) return "Plugin";

      return "Módulo";
    },

    pluralizeQuantityLabel(label, quantity) {
      const normalizedLabel = String(label || "unidades").trim();
      if (Number(quantity) <= 1) return normalizedLabel;
      if (normalizedLabel.endsWith("s")) return normalizedLabel;
      return `${normalizedLabel}s`;
    },

    appPendingRenewalPriceLabel(app) {
      if (app.quantity > 1) {
        return `${app.quantity} ${app.quantityLabel} x R$ ${this.formatValorReal(app.unitPrice)}/mês → R$ ${this.formatValorReal(app.annualPrice)}/ano`;
      }

      return `R$ ${this.formatValorReal(app.totalPrice)}/mês → R$ ${this.formatValorReal(app.annualPrice)}/ano`;
    },

    valorOpcaoTotalComApps(opcao = {}) {
      const parcela = Number(opcao.parcela || 0);
      const valorTotalOpcao = this.readCurrency(opcao.valor_total, opcao.valorTotal);

      if (valorTotalOpcao) {
        return valorTotalOpcao + Number(this.appsPendingRenewalTotalSelecionado);
      }

      const valorBase = this.readCurrency(opcao.valor);
      const valorTotal = parcela > 1 ? valorBase * parcela : valorBase;
      return valorTotal + Number(this.appsPendingRenewalTotalSelecionado);
    },

    valorOpcaoParcelaComApps(opcao = {}) {
      const parcela = Number(opcao.parcela || 1);
      return this.valorOpcaoTotalComApps(opcao) / Math.max(1, parcela);
    },

    valorOpcaoMensalComApps(opcao = {}) {
      return this.readCurrency(opcao.valor) + (Number(this.appsPendingRenewalTotalSelecionado) / 12);
    },

    selecionarTodosAppsPendingRenewal() {
      this.appsPendingRenewalSelecionadosCodes = this.appsPendingRenewalNormalizados.map(
        (app) => app.code,
      );
    },

    isAppPendingRenewalSelected(code) {
      return this.appsPendingRenewalSelecionadosCodes.includes(code);
    },

    toggleAppPendingRenewal(code, checked) {
      if (this.isLoading || this.pixLoading || this.pixConfirmado || this.renovacaoConcluida) return;
      if (!code) return;

      const selected = checked === true || checked === "true" || checked === 1;
      const currentCodes = this.appsPendingRenewalSelecionadosCodes.filter(
        (itemCode) => itemCode !== code,
      );

      this.appsPendingRenewalSelecionadosCodes = selected
        ? [...currentCodes, code]
        : currentCodes;
    },

    appsRenovacaoPayload() {
      return this.appsPendingRenewalSelecionados.map((app) => ({
        code: app.code,
        quantity: app.quantity,
        origin: "monthly_to_yearly",
      }));
    },

    // ===== CardForm handlers =====
    updateCardNumber(v) {
      this.formData.cardNumber = v;
    },
    updateCardName(v) {
      this.formData.cardName = v;
    },
    updateCardMonth(v) {
      this.formData.cardMonth = v;
    },
    updateCardYear(v) {
      this.formData.cardYear = v;
    },
    updateCardCvv(v) {
      this.formData.cardCvv = v;
    },

    togglePlugin(key) {
      if (this.isLoading || this.pixLoading || this.pixConfirmado || this.renovacaoConcluida) return;
      if (!this.plugins?.[key]) return;
      this.plugins[key].ativo = !this.plugins[key].ativo;
    },

    handleBeforeUnload(event) {
      if (!this.bloquearSaidaPix) return;

      event.preventDefault();
      event.returnValue = "";
    },

    // ===== INIT =====
    async getDataInitSafe() {
      this.setLoading(true);
      try {
        this.dataReady = true;
        const dataPlanos = await this.$http.post("/empresa/planos-ativos");

        if (dataPlanos.data) {
          this.planos2026 = dataPlanos.data.planos2026;
        }

        const data = await this.getAssinaturaByClient();
        this.assinaturaResumoPayload = data || {};
        this.assinatura = new AssinaturaData(data);
        this.selecionarTodosAppsPendingRenewal();

        if (this.plugins?.certificado) {
          this.plugins.certificado.ativo = !!data.plugin_certificado;
        }

        if (this.plugins?.tef) {
          this.plugins.tef.ativo = !!data.plugin_tef;
        }

        this.ocultaPlans = !(Number(this.assinatura.id_plan) === 1);

        if (this.assinatura.id_empresa === 1) {
          this.ocultaPlans = false;
        }

        if (this.isRevenda) {
          this.ocultaPlans = false;
        }

        await this.carregarAssinaturas();
      } finally {
        this.setLoading(false);
      }
    },

    async handleCardSuccess() {
      await this.finalizarRenovacao();
    },

    async carregarAssinaturas() {
      this.assinaturasLoading = true;
      try {
        const res = await this.$http.post("/empresa/fatura-assinaturas", {
          id_empresa: this.assinatura.id_empresa
        });
        this.assinaturas = res?.data?.assinaturas || [];
      } catch (e) {
        this.assinaturas = [];
      } finally {
        this.assinaturasLoading = false;
      }
    },

    // ===== Format =====
    formatValorReal(value) {
      const num = Number(String(value ?? 0).replace(",", "."));
      return (isNaN(num) ? 0 : num).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    formatDate(dt) {
      if (!dt) return "";
      if (/^\d{4}-\d{2}-\d{2}$/.test(dt)) {
        const [y, m, d] = dt.split("-").map(Number);
        const date = new Date(y, m - 1, d);
        return date.toLocaleDateString("pt-BR");
      }
      const date = new Date(dt);
      return isNaN(date) ? "" : date.toLocaleDateString("pt-BR");
    },

    formatDateTime(dt) {
      if (!dt) return "";
      const date = new Date(String(dt).replace(" ", "T"));
      return isNaN(date) ? dt : date.toLocaleString("pt-BR");
    },

    // ===== Seleção de pagamento (SEM back aqui) =====
    async selecionarOpcao(key) {
      if (this.isLoading || this.pixLoading || this.pixConfirmado || this.renovacaoConcluida) return;
      this.opcaoSelecionada = key;

      // reset UI final
      this.chamaCartao = false;

      // trocar forma de pagamento invalida pix anterior
      this.resetPixState();

      // só define parcelas (CardForm abre apenas no passo 3, no clicar Renovar agora)
      if (String(key).startsWith("cartao")) {
        const parcela = this.planoAtual?.opcoes?.[key]?.parcela;
        this.vezesByPlan = Number(parcela || 1);
      }
    },

    // ===== CTA FINAL =====
    async iniciarPagamento() {
      if (this.isLoading || this.pixLoading || this.renovacaoConcluida) return;
      if (!this.opcaoSelecionada) {
        this.$toast?.danger?.("Selecione uma forma de pagamento.");
        return;
      }

      if (this.step !== 3) {
        this.step = 3;
        return;
      }

      // PIX: só gera aqui (passo 3)
      if (this.opcaoSelecionada === "pix") {
        const precisaRegerar =
          this.pixLastAmount !== Number(this.valorSelecionado) || !this.pixGerado;

        await this.gerarPixQRCode(precisaRegerar);
        return;
      }

      // Cartão: abre CardForm aqui
      if (String(this.opcaoSelecionada).startsWith("cartao")) {
        this.chamaCartao = true;

        this.$nextTick(() => {
          const el = this.$el.querySelector(".card-resumo");
          el?.scrollIntoView?.({ behavior: "smooth", block: "start" });
        });

        return;
      }

      // Boleto / outros
      await this.finalizarRenovacao();
    },

    // ===== PIX helpers =====
    resetPixState() {
      this.stopPixPolling?.();
      this.pixPaymentId = null;
      this.qrCodePix = null;
      this.codigoPix = null;
      this.pixExpirationDate = null;
      this.pixGerado = false;
      this.pixLastAmount = null;
      this.pixConfirmado = false;
      this.bloquearSaidaPix = false;
    },

    async gerarPixQRCode(force = false) {
      if (this.step !== 3 || this.pixLoading || this.isLoading || this.renovacaoConcluida) return;

      if (!this.valorSelecionado || Number(this.valorSelecionado) <= 0) {
        this.$toast?.danger?.("Não foi possível calcular o valor do PIX.");
        return;
      }

      const pixExpirado = this.pixExpirationDate &&
        new Date(String(this.pixExpirationDate).replace(" ", "T")).getTime() <= Date.now();
      if (!force && !pixExpirado && this.pixPaymentId && this.qrCodePix && this.codigoPix) {
        this.startPixPolling();
        this.pixGerado = true;
        this.bloquearSaidaPix = true;
        return;
      }

      this.stopPixPolling?.();
      this.pixLoading = true;

      this.pixGerado = false;
      this.pixConfirmado = false;
      this.bloquearSaidaPix = true;
      this.qrCodePix = null;
      this.codigoPix = null;
      this.pixPaymentId = null;
      this.pixExpirationDate = null;

      try {
        this.setLoading(true);

        const res = await this.$http.post("/boletos/pix", {
          id_empresa: this.assinatura.id_empresa,
          id_assinatura: this.assinatura.id_assinatura,
          id_plan: this.assinatura.id_plan,
          modalidade: this.modalidadeSelecionada,
          forma_pagamento: "pix",
          valor: this.valorSelecionado,
          email_fatura: this.licenca.email,
          cnpj_cpf: this.assinatura.cnpj_cpf,
          apps_renovacao: this.appsRenovacaoPayload(),
          plugins: Object.keys(this.plugins)
            .filter((k) => this.plugins[k]?.ativo)
            .map((k) => ({
              key: k,
              nome: this.plugins[k].nome,
              valor: this.plugins[k].valor,
            })),
        });

        if (this.telaEncerrada) return;
        const data = res?.data || {};

        this.pixPaymentId = data.id || null;

        if (data.encodedImage) {
          this.qrCodePix = `data:image/png;base64,${data.encodedImage}`;
        } else {
          this.qrCodePix = data.qrcode_base64 || null;
        }

        this.codigoPix = data.payload || data.copia_cola || null;
        this.pixExpirationDate = data.expirationDate || null;

        if (this.pixPaymentId) {
          this.pixGerado = true;
          this.pixLastAmount = Number(this.valorSelecionado);
          this.startPixPolling();
        } else {
          this.bloquearSaidaPix = false;
          this.$toast?.danger?.("Não foi possível gerar o PIX (ID ausente).");
        }
      } catch (e) {
        this.bloquearSaidaPix = false;
        this.$toast?.danger?.(e?.response?.data?.msg || "Erro ao gerar PIX. Tente novamente.");
      } finally {
        this.pixLoading = false;
        this.setLoading(false);
      }
    },

    startPixPolling() {
      this.stopPixPolling();
      if (!this.telaEncerrada && !this.renovacaoConcluida) {
        this.pixPollTimer = setInterval(() => this.checkPixStatus(), 8000);
      }
    },

    stopPixPolling() {
      if (this.pixPollTimer) clearInterval(this.pixPollTimer);
      this.pixPollTimer = null;
    },

    async checkPixStatus() {
      if (!this.pixPaymentId || this.pixStatusLoading || this.renovacaoConcluida || this.telaEncerrada) return;
      const pixPaymentId = this.pixPaymentId;
      this.pixStatusLoading = true;

      try {
        const res = await this.$http.post('/boletos/status-pix/', {
          id_pix: pixPaymentId
        });
        if (this.telaEncerrada || this.pixPaymentId !== pixPaymentId) return;

        const pagamentos = res?.data?.data || [];

        const pagamentoPix = pagamentos.find(
          item => item.pixQrCodeId === this.pixPaymentId
        );

        const status = pagamentoPix?.status;

        if (status === "RECEIVED") {
          this.pixConfirmado = true;
          await this.finalizarRenovacao();
        }
      } catch (e) {
        // mantém polling
      } finally {
        this.pixStatusLoading = false;
      }
    },

    async copiarPix() {
      try {
        await navigator.clipboard.writeText(this.codigoPix || "");
        this.$toast?.success?.("Código PIX copiado!");
      } catch {
        this.$toast?.danger?.("Não foi possível copiar. Copie manualmente.");
      }
    },

    // ===== Boleto / outros =====
    async finalizarRenovacao() {
      if (this.isLoading || this.renovacaoConcluida || this.telaEncerrada) return false;
      if (this.opcaoSelecionada === "pix" && !this.pixConfirmado) return false;
      if (!this.opcaoSelecionada) {
        return this.$toast?.danger?.("Selecione uma forma de pagamento.");
      }

      this.isLoading = true;
      this.setLoading(true);

      try {
        const res = await this.$http.post("/contrato-fatura/assinatura", {
          id_empresa: this.assinatura.id_empresa,
          id_assinatura: this.assinatura.id_assinatura,
          id_plan: this.assinatura.id_plan,
          modalidade: this.modalidadeSelecionada,
          forma_pagamento: this.opcaoSelecionada,
          valor: this.valorSelecionado,
          cnpj_cpf: this.assinatura.cnpj_cpf,
          email_fatura: this.licenca.email,
          apps_renovacao: this.appsRenovacaoPayload(),

          // plugins selecionados (pra registrar do mesmo jeito do pix)
          plugins: Object.keys(this.plugins)
            .filter((k) => this.plugins[k]?.ativo)
            .map((k) => ({
              key: k,
              nome: this.plugins[k].nome,
              valor: this.plugins[k].valor,
            })),
        });

        if (res?.data?.status === false) {
          throw new Error(res.data.msg || "Não foi possível concluir a renovação.");
        }
        this.renovacaoConcluida = true;
        this.bloquearSaidaPix = false;
        this.stopPixPolling();
        this.$toast?.success?.("Renovação iniciada com sucesso!");
        await this.carregarAssinaturas();
        return true;
      } catch (e) {
        this.$toast?.danger?.(e?.response?.data?.msg || e?.message || "Erro ao renovar. Chame um consultor da Nuts.");
        return false;
      } finally {
        this.isLoading = false;
        this.setLoading(false);
      }
    },

    abrirWhatsApp() {
      const numero = "554935500600";
      const mensagem = encodeURIComponent(
        "Olá, estou sem plano ativo no sistema e gostaria de verificar minha assinatura."
      );
      window.open(`https://wa.me/${numero}?text=${mensagem}`, "_blank");
    },

    isOverdue(item) {
      if (item.pagamento) return false;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const due = new Date(item.data_vencimento);
      due.setHours(0, 0, 0, 0);

      return due < today;
    },

    getFaturaStatusMeta(item) {
      const rawStatus = String(item.status_raw || "").toLowerCase();

      if (item.cancelado || ["cancelado", "canceled", "cancelled", "void"].includes(rawStatus)) {
        return { label: "Cancelado", variant: "secondary" };
      }

      if (item.pagamento || ["pago", "paid", "recebido", "received"].includes(rawStatus)) {
        return { label: "Pago", variant: "success" };
      }

      if (this.isOverdue(item) || ["vencido", "overdue", "expired"].includes(rawStatus)) {
        return { label: "Vencido", variant: "danger" };
      }

      return { label: "Pendente", variant: "warning" };
    },
  },
};
</script>

<style lang="scss">
/* visual geral */
.bloco-faturas {
  margin-top: 60px;
  margin-bottom: 150px;
}

.card-form {
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.card-form-assinatura__inner {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
}

.assinatura-page-container {
  width: 100%;
}

.assinatura-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 24px;
  align-items: start;
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  padding: 24px;
}

.assinatura-main-column {
  min-width: 0;
  width: 100%;
}

.assinatura-side-column {
  position: sticky;
  top: 72px;
}

.assinatura-shell-clean {
  background: transparent;
  border: 0;
  box-shadow: none !important;
  width: 100% !important;
  max-width: none !important;
}

.assinatura-shell-clean__inner {
  background: transparent;
  box-shadow: none;
  padding: 0 !important;
  width: 100%;
}

.valor-destaque {
  font-size: 1.5rem;
  font-weight: 800;
  color: #ee7361;
}

.assinatura-top-header {
  padding-top: 8px;
}

/* steps */
.assinatura-steps {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.step-item {
  padding: 10px 18px;
  border-radius: 30px;
  background: #eee;
}

.step-item.active {
  background: #ee7361;
  color: white;
  font-weight: 600;
}

/* cards pagamento */
.pagamentos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 18px;
}

.payment-card {
  flex: 1 1 190px;
  border: 2px solid #eee;
  border-radius: 12px;
  padding: 18px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fff;
}

.payment-card:hover {
  border-color: #ee7361;
  transform: translateY(-3px);
}

.payment-card.selected {
  border-color: #ee7361;
  background: #fff7f5;
}

.payment-title {
  display: flex;
  justify-content: center;
  gap: 8px;
  align-items: center;
}

.price-main {
  font-size: 1.35rem;
  font-weight: 800;
  color: #ee7361;
  margin-top: 10px;
  line-height: 1.2;
}

/* plugins */
.plugins-box {
  background: #f7f9fc;
  padding: 18px;
  border-radius: 12px;
}

.plugin-card {
  border: 2px solid #eee;
  border-radius: 12px;
  padding: 18px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.plugin-card:hover {
  border-color: #ee7361;
  transform: translateY(-3px);
}

.plugin-card.destaque {
  border-color: #ee7361;
  background: #fff7f5;
}

.plugin-badge {
  position: absolute;
  top: -10px;
  left: 15px;
  background: #ee7361;
  color: #fff;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 20px;
}

.plugin-badge.blue {
  background: #4f6df5;
}

.plugin-price {
  margin: 5px 0;
}

.old-price {
  text-decoration: line-through;
  color: #999;
  font-size: 13px;
  margin-right: 6px;
}

.new-price {
  font-size: 18px;
  font-weight: 700;
  color: #ee7361;
}

.plugin-desc {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

/* resumo */
.card-resumo {
  background: #fff;
  border-radius: 10px;
  padding: 24px;
}

.resumo-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 14px;
}

.resumo-total {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  font-weight: 700;
  color: #ee7361;
}

/* PIX */
.pix-box {
  background: #f7f9fc;
  padding: 18px;
  border-radius: 12px;
}

.pix-qrcode {
  max-width: 240px;
  width: 100%;
  border: 1px solid #eee;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
}

/* sem plano */
.plan__table {
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 1024px;
  margin: 0 auto;
}

.plan-card--alert {
  border: 2px solid #ee7361;
  background: #fff7f5;
}

.plan-card--alert .plan-card__header {
  font-weight: 600;
}
.aviso-pix-pendente {
  border: 1px solid #f3c36b;
  background: #fff8e8;
  border-radius: 10px;
}

.pix-warning-text {
  font-size: 13px;
  color: #9a6700;
  background: #fff8e8;
  border: 1px solid #f3c36b;
  padding: 10px 12px;
  border-radius: 8px;
}

.assinatura-overview-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(380px, 0.8fr);
  gap: 24px;
  align-items: stretch;
}

.contratacao-bloco {
  background: #fafbfd;
  border: 1px solid #e2e8f2;
  border-radius: 14px;
  padding: 18px;
}

.valor-destaque--small {
  font-size: 1.25rem;
}

.plano-principal-card,
.apps-contratados-card,
.resumo-financeiro-card,
.renovacao-card,
.faturas-card .card-form-assinatura__inner {
  box-shadow: 0 8px 24px rgba(26, 36, 51, 0.06);
}

.renovacao-card {
  margin-top: 24px;
  padding: 28px;
  background: #fff;
  border: 1px solid #e2e8f2;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(26, 36, 51, 0.06);
  width: 100%;
}

.renovacao-header h5 {
  font-weight: 700;
  color: #1e2a3b;
}

.renovacao-observacao {
  color: #4f6177;
  font-size: 12px;
}

.plano-principal-nome {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1e2a3b;
}

.resumo-financeiro-card {
  background: linear-gradient(180deg, #ffffff 0%, #f6f8fc 100%);
}

.resumo-total--mensal {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px dashed #d4deea;
  font-size: 14px;
  line-height: 1.35;
  color: #4f6177;
}

.resumo-total--mensal strong {
  font-size: 14px;
  color: #1e2a3b;
}

.app-contratado-item {
  padding: 12px 0;
  border-bottom: 1px solid #e7ecf5;
}

.app-contratado-item:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.apps-pending-renewal-card {
  background: #fff;
  border-color: #dbe7f5;
  box-shadow: 0 8px 24px rgba(26, 36, 51, 0.06);
}

.apps-pending-renewal-header {
  border-bottom: 1px solid #edf1f7;
  padding-bottom: 12px;
}

.apps-pending-renewal-list {
  display: grid;
  gap: 8px;
  margin-top: 14px;
}

.app-pending-renewal-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(170px, auto);
  gap: 12px;
  align-items: center;
  border: 1px solid #e7ecf5;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fbfcfe;
}

.app-pending-renewal-checkbox {
  min-width: 0;
  margin-bottom: 0;
}

.app-pending-renewal-name {
  font-weight: 600;
  color: #1e2a3b;
}

.app-pending-renewal-price {
  color: #1e2a3b;
  font-weight: 700;
  text-align: right;
  white-space: nowrap;
}

.apps-pending-renewal-summary {
  margin-top: 12px;
  border-top: 1px dashed #d4deea;
  padding-top: 12px;
}

.resumo-total--apps-pending {
  margin-bottom: 0;
}

.sem-apps-box {
  border: 1px dashed #ccd6e3;
  border-radius: 10px;
  padding: 14px;
  background: #ffffff;
}

.sem-apps-box--highlight {
  background: #fdfefe;
  border-color: #b9d4f0;
}

.app-tipo-label {
  font-size: 12px;
  font-weight: 600;
  color: #4f6177;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.faturas-card {
  margin-bottom: 28px;
}

.faturas-card--inside-main {
  margin-bottom: 0;
}

.faturas-header {
  border-bottom: 1px solid #edf1f7;
  padding-bottom: 8px;
}

.fatura-status-badge {
  min-width: 84px;
  text-align: center;
  font-weight: 600;
}

@media (max-width: 991px) {
  .assinatura-layout {
    grid-template-columns: 1fr;
    padding: 16px;
  }

  .assinatura-main-column {
    order: 2;
  }

  .assinatura-side-column {
    position: static;
    order: 1;
  }

  .contratacao-bloco {
    padding: 14px;
  }

  .app-pending-renewal-item {
    grid-template-columns: 1fr auto;
  }

  .app-pending-renewal-price {
    grid-column: 1 / -1;
    text-align: left;
    white-space: normal;
  }
}
</style>
